import { render } from "./dayStock.vue?vue&type=template&id=6887f7f8&scoped=true"
import script from "./dayStock.vue?vue&type=script&lang=js"
export * from "./dayStock.vue?vue&type=script&lang=js"

import "./dayStock.vue?vue&type=style&index=0&id=6887f7f8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6887f7f8"]])

export default __exports__